package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.TagW500Rounded: ImageVector
    get() {
        if (_tagW500Rounded != null) {
            return _tagW500Rounded!!
        }
        _tagW500Rounded = Builder(name = "TagW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(364.3f, 645.5f)
                lineToRelative(-32.52f, 129.57f)
                quadToRelative(-3.48f, 14.67f, -15.15f, 23.98f)
                quadToRelative(-11.67f, 9.32f, -27.35f, 9.32f)
                quadToRelative(-21.63f, 0.0f, -35.3f, -17.15f)
                quadToRelative(-13.68f, -17.15f, -7.96f, -37.79f)
                lineToRelative(27.05f, -107.93f)
                lineTo(169.8f, 645.5f)
                quadToRelative(-22.63f, 0.0f, -36.3f, -17.53f)
                quadToRelative(-13.67f, -17.54f, -7.96f, -39.17f)
                quadToRelative(3.48f, -15.67f, 15.92f, -24.98f)
                quadToRelative(12.43f, -9.32f, 28.34f, -9.32f)
                horizontalLineToRelative(125.9f)
                lineToRelative(37.37f, -149.0f)
                lineTo(229.8f, 405.5f)
                quadToRelative(-22.63f, 0.0f, -36.3f, -17.53f)
                quadToRelative(-13.67f, -17.54f, -7.96f, -39.17f)
                quadToRelative(3.48f, -15.67f, 15.92f, -24.98f)
                quadToRelative(12.43f, -9.32f, 28.34f, -9.32f)
                horizontalLineToRelative(125.9f)
                lineToRelative(32.52f, -129.57f)
                quadToRelative(3.48f, -14.67f, 15.15f, -23.86f)
                quadToRelative(11.67f, -9.2f, 27.35f, -9.2f)
                quadToRelative(21.63f, 0.0f, 35.3f, 17.15f)
                quadToRelative(13.68f, 17.15f, 7.96f, 37.78f)
                lineToRelative(-27.05f, 107.7f)
                lineTo(595.7f, 314.5f)
                lineToRelative(32.52f, -129.57f)
                quadToRelative(3.48f, -14.67f, 15.15f, -23.86f)
                quadToRelative(11.67f, -9.2f, 27.35f, -9.2f)
                quadToRelative(21.63f, 0.0f, 35.3f, 17.15f)
                quadToRelative(13.68f, 17.15f, 7.96f, 37.78f)
                lineToRelative(-27.05f, 107.7f)
                lineTo(790.2f, 314.5f)
                quadToRelative(22.63f, 0.0f, 36.3f, 17.53f)
                quadToRelative(13.67f, 17.54f, 7.96f, 39.17f)
                quadToRelative(-3.48f, 15.67f, -15.92f, 24.98f)
                quadToRelative(-12.43f, 9.32f, -28.34f, 9.32f)
                lineTo(664.3f, 405.5f)
                lineToRelative(-37.37f, 149.0f)
                lineTo(730.2f, 554.5f)
                quadToRelative(22.63f, 0.0f, 36.3f, 17.53f)
                quadToRelative(13.67f, 17.54f, 7.96f, 39.17f)
                quadToRelative(-3.48f, 15.67f, -15.92f, 24.98f)
                quadToRelative(-12.43f, 9.32f, -28.34f, 9.32f)
                lineTo(604.3f, 645.5f)
                lineToRelative(-32.52f, 129.57f)
                quadToRelative(-3.48f, 14.67f, -15.15f, 23.98f)
                quadToRelative(-11.67f, 9.32f, -27.35f, 9.32f)
                quadToRelative(-21.63f, 0.0f, -35.3f, -17.15f)
                quadToRelative(-13.68f, -17.15f, -7.96f, -37.79f)
                lineToRelative(27.05f, -107.93f)
                lineTo(364.3f, 645.5f)
                close()
                moveTo(386.93f, 554.5f)
                lineTo(535.7f, 554.5f)
                lineToRelative(37.37f, -149.0f)
                lineTo(424.3f, 405.5f)
                lineToRelative(-37.37f, 149.0f)
                close()
            }
        }
        .build()
        return _tagW500Rounded!!
    }

private var _tagW500Rounded: ImageVector? = null
